@if (!editMode) {
  <div class="tw:px-[15px]">

    <!-- Header: time + status pill + open link -->
    <div class="tw:flex tw:flex-wrap tw:items-center tw:gap-3 tw:mb-4">
      <span class="tw:text-xs tw:text-[#888]">{{ timelineSection.startTime }} - {{ timelineSection.endTime }}</span>
      @if (statusLabel()) {
        <span class="badge badge-pill pr-status" [ngClass]="statusClass()">{{ statusLabel() }}</span>
      }
      @if (hasReport()) {
        <a class="tw:ml-auto tw:text-xs tw:font-semibold tw:text-[#4b3db5] tw:cursor-pointer" (click)="openReport()">View session report</a>
      }
    </div>

    <!-- Meta -->
    <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-x-6 tw:gap-y-1 tw:mb-4">
      <div class="kvp"><div class="kvp__k">Session type:</div><div class="kvp__v">{{ timelineSection.sessionType }}</div></div>
      <div class="kvp"><div class="kvp__k">Delivery mode:</div><div class="kvp__v">{{ timelineSection.sessionDelivery }}</div></div>
      <div class="kvp"><div class="kvp__k">Subject:</div><div class="kvp__v">{{ timelineSection.subject }}</div></div>
      <div class="kvp"><div class="kvp__k">Attendance:</div><div class="kvp__v">{{ timelineSection.attendance }}</div></div>
      @if (timelineSection.reason) {
        <div class="kvp"><div class="kvp__k">Reason:</div><div class="kvp__v">{{ timelineSection.reason }}</div></div>
        @if (timelineSection.reasonDescription) {
          <div class="kvp"><div class="kvp__k">Comments:</div><div class="kvp__v">{{ timelineSection.reasonDescription }}</div></div>
        }
      }
      @if (timelineSection.evidence?.length) {
        <div class="kvp">
          <div class="kvp__k">Evidence:</div>
          <div class="kvp__v">
            <!-- Each file opens through the API, which checks the caller may see it. -->
            @for (f of timelineSection.evidence; track $index) {
              <a class="session-evidence tw:block" href="" (click)="openEvidence($event, f)">{{ f.name }}</a>
            }
          </div>
        </div>
      }
    </div>

    <!-- Two-column: Attainment & Progress | Engagement -->
    <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-6">

      <div class="tw:flex tw:flex-col tw:gap-3">
        <div class="kvp__k kvp__k--heading">Attainment &amp; Progress</div>

        @for (objective of timelineSection.objectives; track $index) {
          <div class="tw:flex tw:flex-col tw:gap-1">
            <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Learning objective {{ $index + 1 }}</span>
            <div class="kvp__v kvp__v--long-text">{{ objective.text }}</div>
            @if (objective.attainmentLevel >= 0) {
              <leap-v2-scale-slider [value]="objective.attainmentLevel" [min]="0" [max]="4"
                                    [labels]="attainmentLabels" [colourRamp]="true" [disabled]="true">
              </leap-v2-scale-slider>
            } @else {
              <span class="tw:text-[11px] tw:text-[#bbb]">Not set</span>
            }
          </div>
        } @empty {
          <div class="tw:text-[13px] tw:text-[#888]">No learning objectives recorded.</div>
        }

        <div class="kvp kvp--stacked">
          <div class="kvp__k kvp__k--heading">Comments on progress:</div>
          <div class="kvp__v kvp__v--long-text">{{ timelineSection.learningComment }}</div>
        </div>
      </div>

      <div class="tw:flex tw:flex-col tw:gap-3">
        <div class="kvp__k kvp__k--heading">Engagement</div>

        <div class="tw:flex tw:flex-col tw:gap-1">
          <span class="tw:text-xs tw:font-semibold tw:text-[#333]">Engagement score</span>
          @if (timelineSection.engagementRating) {
            <leap-v2-scale-slider [value]="timelineSection.engagementRating" [min]="1" [max]="5"
                                  [labels]="engagementLabels" [disabled]="true">
            </leap-v2-scale-slider>
          } @else {
            <span class="tw:text-[11px] tw:text-[#bbb]">Not set</span>
          }
        </div>

        <div class="kvp kvp--stacked">
          <div class="kvp__k kvp__k--heading">Engagement comments:</div>
          <div class="kvp__v kvp__v--long-text">{{ timelineSection.engagementComment }}</div>
        </div>
      </div>

    </div><!-- /two-column -->

  </div>
}
